
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { MAGIC_TWO } from '@/config/config';
import Swiper from 'swiper';
import { formatName, pushBy2804 } from '@/utils/tools';
import { updateRead } from '@/apis/index';
@Component
export default class FloatAvatar extends Vue {
  //当前选中的id
  chooseId: any = '';
  //是否为黑夜模式
  blackMode = null;
  @Prop() private list!: Array<object>;
  @Prop() private swiperIndex!: number;
  @Prop() private chooseAvatar!: number;
  @Prop() private length1!: number;
  @Prop() private length2!: number;
  @Prop() private author!: string;
  @Prop() private id!: string;
  formatName = formatName;
  industryAvatar = {
    color: '#FF9500',
    background: 'rgba(255,149,0,0.10)',
  };
  mechanismAvatar = {
    color: '#FF2436',
    background: 'rgba(255, 36, 54, 0.1)',
  };
  formatStyle() {
    if (this.swiperIndex === 1) {
      return this.mechanismAvatar;
    } else if (this.swiperIndex === 2) {
      return this.industryAvatar;
    } else {
      return '';
    }
  }
  showRound = false;
  swiper: any = null;
  getIndex = 0;
  getWatch = 0;
  @Watch('chooseAvatar', { immediate: true, deep: true })
  chooseAvatarChange() {
    this.$nextTick(() => {
      this.checkedAvatarWhenPop();
    });
  }
  chooseMore() {
    pushBy2804('/myFollow', null);
    this.$emit('closePop');
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity
  dealOpacity(index: number, item: any, swipeIndex: number, operate: string) {
    //选中时透明度为1，其他为0.6
    if (operate === 'slide') {
      if (swipeIndex === 1) {
        this.chooseId = item.orgId;
        this.getIndex = this.length1 + index;
      } else if (swipeIndex === MAGIC_TWO) {
        this.chooseId = item.industryId;
        this.getIndex = this.length2 + index;
      } else {
        this.chooseId = item.authorId;
        this.getIndex = index;
      }
    } else {
      if (this.swiperIndex === 1) {
        this.chooseId = item.orgId;
        this.getIndex = this.length1 + index;
      } else if (this.swiperIndex === MAGIC_TWO) {
        this.chooseId = item.industryId;
        this.getIndex = this.length2 + index;
      } else {
        this.chooseId = item.authorId;
        this.getIndex = index;
      }
      this.$emit('swiperSlide', this.getIndex);
    }
    const avatar = document.getElementsByClassName('avatar-card2');
    for (let i = 0; i < avatar.length; i++) {
      for (let j = 0; j < avatar[i].children.length; j++) {
        const node1 = avatar[i].children[j] as HTMLElement;
        node1.style.opacity = '0.6';
        const node = avatar[this.getIndex].children[j] as HTMLElement;
        const avatarNode = avatar[this.getIndex] as HTMLElement;
        node.style.opacity = '1';
        window.sessionStorage.setItem(
          'triangleLeft',
          JSON.stringify([
            this.swiperIndex,
            avatarNode.getBoundingClientRect().left + avatarNode.offsetWidth / MAGIC_TWO,
          ])
        );
        this.$emit(
          'changeTriangle',
          avatarNode.getBoundingClientRect().left + avatarNode.offsetWidth / MAGIC_TWO
        );
      }
    }
  }
  checkAvatar(name: string, index: number, item: any, id: string, swipeIndex: number, operate: string) {
    if (item.isUpdate) {
      updateRead({
        follow_id: item.industryId || item.orgId || item.authorId,
      }).then(() => {
        item.isUpdate = !item.isUpdate;
        const newList = this.list as any;
        newList[index].isUpdate = 0;
        if (item.industryId) {
          window.sessionStorage.setItem('industry', JSON.stringify(newList));
        } else if (item.orgId) {
          window.sessionStorage.setItem('org', JSON.stringify(newList));
        } else {
          window.sessionStorage.setItem('author', JSON.stringify(newList));
        }
        this.showRound = true;
        this.$emit('changeStatus');
      });
    }

    this.$emit('changeName', name, id);
    this.dealOpacity(index, item, swipeIndex, operate);
  }
  // eslint-disable-next-line consistent-return
  checkedAvatar(name: string, index: number, item: any, id: string, swipeIndex: number, operate: string) {
    this.checkAvatar(name, index, item, id, swipeIndex, operate);
  }
  //点击外层头像唤起浮层时使选中的头像在内层透明度为1
  checkedAvatarWhenPop() {
    this.$emit('changeName', this.author, this.id);
    //选中时透明度为1，其他为0.6
    this.getWatch = this.chooseAvatar;
    const avatar = document.getElementsByClassName('avatar-card2');
    for (let i: number = 0; i < avatar.length; i++) {
      for (let j = 0; j < avatar[i].children.length; j++) {
        const node = avatar[i].children[j] as HTMLElement;
        node.style.opacity = '0.6';
      }
    }
    for (let i = 0; i < avatar[this.getWatch].children.length; i++) {
      const node = avatar[this.getWatch].children[i] as HTMLElement;
      const firstNode = avatar[0] as HTMLElement;
      const getNode = avatar[this.getWatch] as HTMLElement;
      node.style.opacity = '1';
      //进入浮层时将第一个头像中间距离屏幕左侧的数值记住，切换浮层tab时将箭头指向第一个头像
      window.sessionStorage.setItem(
        'triangleFirst',
        String(firstNode.getBoundingClientRect().left + firstNode.offsetWidth / MAGIC_TWO)
      );
      //进入浮层时记住当前三角的位置，切换tab回来时将三角展示在记住的位置
      window.sessionStorage.setItem(
        'triangleLeft',
        JSON.stringify([
          this.swiperIndex,
          getNode.getBoundingClientRect().left + getNode.offsetWidth / MAGIC_TWO,
        ])
      );
      this.$emit('changeTriangle', getNode.getBoundingClientRect().left + getNode.offsetWidth / MAGIC_TWO);
    }
  }
  mounted() {
    this.blackMode = this.$isBlack;
    this.chooseId = this.id;
    this.$nextTick(() => {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      this.swiper = new Swiper('#avatarCard2', {
        freeMode: true,
        slidesPerView: 'auto',
        normalizeSlideIndex: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
    });
  }
}
